import { baseConfig } from "config";
import { BaseDocumentFolder, DocumentFolderType } from "services/types";
import * as Yup from "yup";

const ValidationHelper = {
	validateFolderDocumentCount(documentFolder: BaseDocumentFolder, folderTypeData: DocumentFolderType | undefined, forceRequired = false): boolean {
		const { documents } = documentFolder;
		const isTestExecutable = folderTypeData && documents;
		if (!isTestExecutable) return Boolean(!isTestExecutable);

		const folderHasNoDocument = documents.length === 0;
		const isDocumentsOptional = !folderTypeData.alwaysRequired && folderHasNoDocument && !forceRequired;
		const isDocumentsExceeded = documents.length >= folderTypeData.minAmountDocuments;
		return Boolean(isDocumentsOptional || isDocumentsExceeded);
	},
	validateMaximumDocumentCount(value: Record<string, BaseDocumentFolder>) {
		const totalDocuments = Object.values(value).reduce((acc, folder) => acc + folder.documents.length, 0);
		return totalDocuments <= baseConfig.maxSubmissionApplicationFiles;
	},
	validateFolderDocumentGroup(this: Yup.TestContext<any>, value: BaseDocumentFolder, folderTypeById: Record<string, DocumentFolderType>) {
		const folderTypes = Object.values(this.parent) as { documents: any[]; exemptionDocumentFolderType: string }[];
		const { requiredDocumentTypeGroup } = folderTypeById[value.exemptionDocumentFolderType];
		const folderTypesFromSameGroup = folderTypes.filter(
			(folderType) =>
				requiredDocumentTypeGroup != null &&
				folderTypeById[folderType.exemptionDocumentFolderType].requiredDocumentTypeGroup === requiredDocumentTypeGroup
		);
		return folderTypesFromSameGroup.some((folderType) => folderType.documents.length > 0) || !requiredDocumentTypeGroup;
	},
	documentMinimumCountMessage: "Adicione a quantidade mínima de arquivos para a pasta",
	requiredGroupMessage: "Adicione arquivos a pelo menos uma das pastas indicadas",

	buildDocumentFoldersSchema(
		folderKeys: string[],
		folderTypeById: Record<string, DocumentFolderType>,
		baseFolderSchema: Yup.AnyObjectSchema,
		forceAllRequired = false
	): Yup.AnyObjectSchema {
		return Yup.object()
			.shape(
				Object.fromEntries(
					folderKeys.map((folderKey) => [
						folderKey,
						baseFolderSchema
							.test(
								"minDocumentsTest",
								ValidationHelper.documentMinimumCountMessage,
								// eslint-disable-next-line func-names
								function (value: BaseDocumentFolder) {
									return ValidationHelper.validateFolderDocumentCount(
										value,
										folderTypeById[value.exemptionDocumentFolderType],
										forceAllRequired
									);
								}
							)
							// eslint-disable-next-line func-names
							.test("requiredDocumentTypeGroupTest", ValidationHelper.requiredGroupMessage, function (value: BaseDocumentFolder) {
								return ValidationHelper.validateFolderDocumentGroup.call(this, value, folderTypeById);
							})
					])
				)
			)
			.test(
				"maxSubmissionApplicationFiles",
				`É possível anexar no máximo ${baseConfig.maxSubmissionApplicationFiles} arquivos`,
				// eslint-disable-next-line func-names
				function (val) {
					const totalDocuments = Object.values(val as Record<string, BaseDocumentFolder>).reduce(
						(acc, folder) => acc + folder.documents.length,
						0
					);
					return totalDocuments <= baseConfig.maxSubmissionApplicationFiles;
				}
			);
	}
};
export default ValidationHelper;
